import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication.service';

@Directive({
  selector: '[showIfHasFeatureFlag]'
})
export class ShowIfHasFeatureFlagDirective implements OnInit {

  @Input('showIfHasFeatureFlag') public featureName: string;

  public constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly authenticationService: AuthenticationService
  ) {}


  public ngOnInit(): void {
    if (this.authenticationService.hasFlags(this.featureName)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
